(function () {
    'use strict';

    angular
        .module('app')
        .controller('HostsController', HostsController);

    HostsController.$inject = ['$http', '$stateParams', '$rootScope', '$timeout', '$state', 'cache', 'authenticator', 'localization', '$cookies', '$scope'];

    function HostsController($http, $stateParams, $rootScope, $timeout, $state, cache, authenticator, localization, $cookies, $scope) {
        $rootScope.header_inverted = true;
        $rootScope.on_dashboard = false;
        $rootScope.separate_page = false;
        $rootScope.dark_text_header = true;
        var vm = this;
        vm.resultsPerPage = 21;
        vm.page = 1;
        vm.$onInit = init;
        vm.offset = 0;
        vm.freetext = "";
        vm.searchString = "";
        vm.dateRangeStart = new Date();
        vm.activeFilters = 0;
        vm.getHosts = getHosts;
        vm.getSelectedLocations = getSelectedLocations;
        vm.getSelectedSpaceTypes = getSelectedSpaceTypes;
        vm.getSelectedStatuses = getSelectedStatuses;
        vm.getSelectedSeatRanges = getSelectedSeatRanges;
        vm.getSelectedSortingOrders = getSelectedSortingOrders;
        vm.countActiveMoreFilters = countActiveMoreFilters;
        vm.countActiveMobileFilters = countActiveMobileFilters;
        vm.search = search;
        vm.selectLocation = selectLocation;
        vm.selectSpaceType = selectSpaceType;
        vm.selectStatus = selectStatus;
        vm.selectSeatRange = selectSeatRange;
        vm.selectSortingOrder = selectSortingOrder;
        vm.searchBlur = searchBlur;
        vm.searchOnEnter = searchOnEnter;
        vm.searchInputFocus = searchInputFocus;
        vm.clearText = clearText;
        vm.clearSearchAndFilters = clearSearchAndFilters;
        vm.toggleFilterSort = toggleFilterSort;
        vm.toggleLocationFilter = toggleLocationFilter;
        vm.toggleMoreFilter = toggleMoreFilter;
        vm.toggleSortFilter = toggleSortFilter;
        vm.toggleSearchFilter = toggleSearchFilter;
        vm.closeFilters = closeFilters;
        vm.updatePage = updatePage;
        vm.chosenLocations;
        vm.navigateToHost = navigateToHost;
        vm.favourite = favourite;
        vm.locationChanged = locationChanged;
        vm.locations = [];
        vm.spaceTypes = [
            { spaceType: "Private home", spaceTypeSlug: "private_home" },
            { spaceType: "Outdoor", spaceTypeSlug: "outdoors" },
            { spaceType: "Workspace", spaceTypeSlug: "workspace" },
            { spaceType: "Other", spaceTypeSlug: "other" },
            // { spaceType: "Private", spaceTypeSlug: "private" },
            // { spaceType: "Bar and café", spaceTypeSlug: "bar_and_cafe" },
            // { spaceType: "Music venue", spaceTypeSlug: "music_venue" },
        ];
        vm.statuses = [
            { status: "Superhost", statusSlug: "superhost" }
        ];
        vm.seatRanges = [
            { seatRange: "10-20", range: { from: 1, to: 20 } }, // We don't wan't people to know that there are spaces with less than ten seats, so we show it as '10-20 seats'
            { seatRange: "20-40", range: { from: 20, to: 40 } },
            { seatRange: "40+", range: { from: 40, to: 9999 } } // What IS the maximum number of seats we want to show?
        ];
        vm.sortingOrders = [
            { sortingOrder: 'Relevance', sortingOrderSlug: 'relevance' },
            { sortingOrder: 'Newest to oldest', sortingOrderSlug: 'newest_to_oldest' },
            { sortingOrder: 'Name', sortingOrderSlug: 'name' },
            { sortingOrder: 'Most concerts', sortingOrderSlug: 'most_concerts' }
        ];

        $scope.$on('$destroy', function () {
            $rootScope.dark_text_header = false;
        });

        function init() {
            window.document.title = $stateParams.language == 'da' ? "Værter – Be My Concert" : "Hosts – Be My Concert";
            vm.hosts = [];
            if(!localization.location){
                vm.current_location = $cookies.get('selected_location');
            }else{
                vm.current_location = localization.location;
            }
            if(vm.current_location != 'Sweden' && vm.current_location != 'Denmark'){
                vm.current_location = 'Denmark';
            }
            changeCurrentLocationIso();
            getCountryRegions();
            getLoggedIn();
        }

        function locationChanged() {
            vm.current_location = localization.location;
            vm.country_filter = vm.current_location;
            vm.page = 1;
            changeCurrentLocationIso();
            clearSelectedLocations();
            setCountryRegions();
            getHosts();
            updatePage();
        }

        function getLoggedIn() {
            authenticator.checkLoginStatus()
                .then(function (isLoggedIn) {
                    vm.logged_in = isLoggedIn;
                });
        }

        function favourite(e, host) {
            e.preventDefault();
            e.stopPropagation();
            if (!vm.logged_in) {
                var backState = angular.copy($stateParams);
                return $state.go('login', { 'backToStateName': 'hosts', 'backToStateParams': backState });
            } else {
                host['favorite'] = !host['favorite'];
                host.is_favorite = !host.is_favorite;
                $scope.$applyAsync();
                $http.patch('api/favorite_host/' + host.space_slug + '/')
                .then(function (response) {
                    getHosts(1);
                });

            }
        }

        function navigateToHost(host) {
            cache.save('scrollY', window.scrollY);
        }

        function clearSearchAndFilters() {
            vm.dateFilter = 'any';
            vm.dateRangeStart = new Date();
            vm.dateRangeEnd = null;
            vm.locations.forEach(function (location) {
                location.selected = false;
            });
            vm.spaceTypes.forEach(function (spaceType) {
                spaceType.selected = false;
            });
            vm.statuses.forEach(function (status) {
                status.selected = false;
            });
            vm.seatRanges.forEach(function (seatRange) {
                seatRange.selected = false;
            });
            vm.sortingOrders.forEach(function (sortingOrder) {
                sortingOrder.selected = false;
            });
            vm.sortingOrders[0].selected = true;
            setActiveFilters();
            setFilterState();
            clearText();
            search();
        }

        function clearSelectedLocations() {
            vm.locations.forEach(function (location) {
                location.selected = false;
            });
        }

        function clearText() {
            vm.freetext = '';
            vm.showSearch = false;
            vm.showSearchResults = false;
            if (cache.load('searchData').freetext != "") {
                search();
            }
        }

        function searchBlur(event) {
            if (vm.freetext != '') {
                setTimeout(function () { vm.searchFocus = false; }, 0);
            } else {
                vm.searchFocus = false;
            }
        }

        function searchOnEnter(event){
            if (event.keyCode == 13){
                search();
            }
        }

        function searchInputFocus(elementID){
            vm.showSearch = !vm.showSearch;
            vm.searchFocus = true;
            var element = document.getElementById(elementID);
            setTimeout(function(){
                element.focus();
            }, 200);
        }

        function setFilterFromState() {
            if ($stateParams.location != 'all') {
                var URILocations = decodeURI($stateParams.location).split(';');
                vm.locations.forEach(function (location) {
                    URILocations.forEach(function (URILocation) {
                        if (location.country_region_name == URILocation) {
                            location.selected = true;
                        }
                    });
                });
            }
            if ($stateParams.spaceType != '') {
                var URISpaceTypes = decodeURI($stateParams.spaceType).split(';');
                vm.spaceTypes.forEach(function (spaceType) {
                    URISpaceTypes.forEach(function (URISpaceType) {
                        if (spaceType.spaceTypeSlug == URISpaceType) {
                            spaceType.selected = true;
                        }
                    });
                });
            }
            if ($stateParams.status != '') {
                var URIStatuses = decodeURI($stateParams.status).split(';');
                vm.statuses.forEach(function (status) {
                    URIStatuses.forEach(function (URIStatus) {
                        if (status.statusSlug == URIStatus) {
                            status.selected = true;
                        }
                    });
                });
            }
            if ($stateParams.seatRange != '') {
                var URISeatRanges = decodeURI($stateParams.seatRange).split(';');
                vm.seatRanges.forEach(function (seatRange) {
                    URISeatRanges.forEach(function (URISeatRange) {
                        if (seatRange.seatRange == URISeatRange) {
                            seatRange.selected = true;
                        }
                    });
                });
            }
            //if ($stateParams.sortingOrder != 'newest_to_oldest') {
            var URISortingOrders = decodeURI($stateParams.sortingOrder).split(';');
            vm.sortingOrders.forEach(function (sortingOrder) {
                URISortingOrders.forEach(function (URISortingOrder) {
                    if (sortingOrder.sortingOrderSlug == URISortingOrder) {
                        sortingOrder.selected = true;
                    }
                });
            });
            //}

            if ($stateParams.page != '1') {
                vm.page = $stateParams.page;
            }

            vm.freetext = $stateParams.search;
            vm.country_filter = $stateParams.country_filter != "" ? $stateParams.country_filter : vm.current_location;

            setActiveFilters()
        }

        function selectLocation(location) {
            location.selected = !location.selected;
            setFilterState();
            search();
        }

        function selectSpaceType(spaceType) {
            spaceType.selected = !spaceType.selected;
            setFilterState();
            search();
        }

        function selectStatus(status) {
            status.selected = !status.selected;
            setFilterState();
            search();
        }

        function selectSeatRange(seatRange) {
            seatRange.selected = !seatRange.selected;
            setFilterState();
            search();
        }

        function selectSortingOrder(sortingOrder) {
            vm.sortingOrders.forEach(function (sortingOrder) {
                sortingOrder.selected = false;
            });
            sortingOrder.selected = !sortingOrder.selected;
            setFilterState();
            search();
        }

        function setFilterState() {
            var params = JSON.parse(JSON.stringify($stateParams));
            if (getSelectedLocations().length > 0) {
                var uriString = '';
                getSelectedLocations().forEach(function (location) {
                    if (uriString.length > 0) uriString += ';';
                    uriString += encodeURI(location.country_region_name);
                });
                params.location = uriString;
            } else {
                params.location = 'all';
            }
            if (getSelectedSpaceTypes().length > 0) {
                var uriString = '';
                getSelectedSpaceTypes().forEach(function (spaceType) {
                    if (uriString.length > 0) uriString += ';';
                    uriString += encodeURI(spaceType.spaceTypeSlug);
                });
                params.spaceType = uriString;
            } else {
                params.spaceType = 'all';
            }
            if (getSelectedStatuses().length > 0) {
                var uriString = '';
                getSelectedStatuses().forEach(function (status) {
                    if (uriString.length > 0) uriString += ';';
                    uriString += encodeURI(status.statusSlug);
                });
                params.status = uriString;
            } else {
                params.status = 'all';
            }
            if (getSelectedSeatRanges().length > 0) {
                var uriString = '';
                getSelectedSeatRanges().forEach(function (seatRange) {
                    if (uriString.length > 0) uriString += ';';
                    uriString += encodeURI(seatRange.seatRange);
                });
                params.seatRange = uriString;
            } else {
                params.seatRange = 'all';
            }
            if (getSelectedSortingOrders().length > 0) {
                var uriString = '';
                getSelectedSortingOrders().forEach(function (sortingOrder) {
                    if (uriString.length > 0) uriString += ';';
                    uriString += encodeURI(sortingOrder.sortingOrderSlug);
                });
                params.sortingOrder = uriString;
            } else {
                params.sortingOrder = 'newest_to_oldest';
            }

            params.page = vm.page;
            params.search = vm.freetext;
            params.country_filter = vm.country_filter;

            var scrollY = window.scrollY;
            $state.transitionTo(
                'hosts',
                params,
                {
                    location: true, // This makes it update URL
                    inherit: true,
                    relative: $state.$current,
                    notify: false // This makes it not reload
                }
            ).then(function () {
                setTimeout(function () {
                    window.scrollTo(0, scrollY);
                }, 0);
            })
        }

        function setActiveFilters() {
            var num = 0;
            num += getSelectedSpaceTypes().length;
            num += getSelectedStatuses().length;
            num += getSelectedSeatRanges().length;
            vm.activeFilters = num;
        }

        function toggleFilterSort() {
            vm.showFilterSort = !vm.showFilterSort;
            $rootScope.no_scroll = vm.showFilterSort;
        }

        function toggleLocationFilter() {
            vm.showLocation = !vm.showLocation;
            $rootScope.no_scroll = vm.showLocation;
        }

        function toggleMoreFilter() {
            vm.showMore = !vm.showMore;
            $rootScope.no_scroll = vm.showMore;
        }

        function toggleSortFilter() {
            vm.showSort = !vm.showSort;
            $rootScope.no_scroll = vm.showSort;
        }

        function toggleSearchFilter() {
            vm.showSearch = !vm.showSearch;
            $rootScope.no_scroll = vm.showSearch;
        }

        function closeFilters() {
            vm.showLocation = false;
            vm.showMore = false;
            vm.showSort = false;
            vm.showSearch = false;
            vm.showFilterSort = false;
            $rootScope.no_scroll = false;
        }

        function getSelectedLocations() {
            var selectedLocations = [];
            vm.locations.forEach(location => {
                if (location.selected) selectedLocations.push(location);
            });
            return selectedLocations;
        }

        function getSelectedSpaceTypes() {
            var selectedSpaceTypes = [];
            vm.spaceTypes.forEach(spaceType => {
                if (spaceType.selected) selectedSpaceTypes.push(spaceType);
            });
            return selectedSpaceTypes;
        }

        function getSelectedStatuses() {
            var selectedStatuses = [];
            vm.statuses.forEach(status => {
                if (status.selected) selectedStatuses.push(status);
            });
            return selectedStatuses;
        }

        function getSelectedSeatRanges() {
            var selectedSeatRanges = [];
            vm.seatRanges.forEach(seatRange => {
                if (seatRange.selected) selectedSeatRanges.push(seatRange);
            });
            return selectedSeatRanges;
        }

        function getSelectedSortingOrders() {
            var selectedSortingOrders = [];
            vm.sortingOrders.forEach(sortingOrder => {
                if (sortingOrder.selected) selectedSortingOrders.push(sortingOrder);
            });
            return selectedSortingOrders;
        }

        function countActiveMoreFilters(){
            var count = 0;
            count += getSelectedSeatRanges().length + getSelectedSpaceTypes().length + getSelectedStatuses().length;
            return count;
        }

        function countActiveMobileFilters() {
            var count = 0;
            count += getSelectedSeatRanges().length + getSelectedSpaceTypes().length + getSelectedStatuses().length;
            vm.sortingOrders.forEach(function (sortingOrder) {
                if(sortingOrder.selected){
                    if (sortingOrder.sortingOrderSlug == 'name' || sortingOrder.sortingOrderSlug == 'most_concerts'){
                        count++;
                    }
                }
            });
            return count;
        }

        function getHosts(favourite) {
            var offset = (vm.page - 1) * vm.resultsPerPage;
            var data = {
                'freetext': vm.freetext,
                'country' : localization.getLocationIso(vm.country_filter),
                'location': getSelectedLocations(),
                'spaceType': getSelectedSpaceTypes(),
                'status': getSelectedStatuses(),
                'seatRange': getSelectedSeatRanges(),
                'sortingOrder': getSelectedSortingOrders(),
                'limit': vm.resultsPerPage,
                'offset': offset
            }
            if (cache.exists('hosts') && cache.exists('searchData') && cache.equals('searchData', data) && !favourite) {
                vm.hosts = cache.load('hosts');
                vm.allResultsCount = cache.load('allResultsCount');
                updateViewState();
                if ($rootScope.previousURL.search('/host/') != -1) {
                    setTimeout(function () {
                        window.scrollTo(0, cache.load('scrollY'));
                    }, 0);
                }
                return;
            }
            if (vm.freetext != "") {
                vm.searchString = vm.freetext;
            } else {
                vm.searchString = "";
            }
            return $http.post('api/spaces/list', data)
                .then(function (response) {
                    if (offset > 0) {
                        vm.hosts = vm.hosts.concat(response.data.data);
                    } else {
                        vm.hosts = response.data.data;
                    }
                    if (vm.hosts.length == 0) {
                        vm.showNoResults = true;
                    } else {
                        vm.showNoResults = false;

                        if (vm.searchString != "") {
                            vm.showSearchResults = true;
                            vm.searchFocus = false;
                        } else {
                            vm.showSearchResults = false;
                        }
                    }
                    vm.hosts = response.data.data;
                    vm.allResultsCount = response.data.all_results_count;
                    saveState(data, response.data.all_results_count);
                    updateViewState();
                    return response;
                })
        }

        function updateViewState() {
            vm.searchString = vm.freetext != "" ? vm.freetext : "";
            if (vm.hosts.length == 0) {
                vm.showNoResults = true;
            } else {
                vm.showNoResults = false;

                if (vm.searchString != "") {
                    vm.showSearchResults = true;
                    vm.searchFocus = true;
                } else {
                    vm.showSearchResults = false;
                }
            }
        }

        function saveState(searchData, allResultsCount) {
            cache.save('searchData', searchData);
            cache.save('hosts', vm.hosts);
            cache.save('allResultsCount', allResultsCount);
        }

        function updatePage(page) {
            if (page > 0 && page <= Math.ceil(parseInt(vm.allResultsCount) / vm.resultsPerPage)) {
                vm.page = page;
                getHosts();
                setFilterState();
            }
        }

        function getCountryRegions() {
            if(!cache.exists('hostCountryRegions')){
                $http.get('api/space_country_regions/')
                .then(function (response) {
                    vm.allCountryRegions = response.data;
                    cache.save('hostCountryRegions', vm.allCountryRegions);
                    if(vm.current_location){
                        setCountryRegions();
                    }
                })
                .then(function (response) {
                    setFilterFromState();
                })
                .then(function (response) {
                   getHosts();
                });
            } else {
                loadRegionsFromCache();
                setFilterFromState();
                getHosts();
            }
        }

        function loadRegionsFromCache() {
            vm.allCountryRegions = cache.load('hostCountryRegions');
            if(vm.current_location){
                setCountryRegions();
            }
        }

        function setCountryRegions() {
            vm.countryRegions = vm.allCountryRegions.filter(function(countryRegion) {
                return countryRegion.country_iso_code == vm.current_location_iso;
            });
            vm.locations = vm.countryRegions;
        }

        function search() {
            vm.offset = 0;
            vm.allResultsCount = undefined;
            vm.page = 1;
            getHosts();
            setActiveFilters();
            setFilterState();
        }

        function changeCurrentLocationIso(){
            if(vm.current_location == "Denmark"){
                vm.current_location_iso = "DK"
            }
            if(vm.current_location == "Sweden"){
                vm.current_location_iso = "SE"
            }
        }

        function changeOffset(response) {
            vm.offset = response.data.offset;
            vm.load_more_count = response.data.load_more_count;
        }

    }
})();
